export default "__VITE_ASSET__DvIosasS__"